import { addDays, addMonths } from 'date-fns/esm/fp';

import { formatMonthDayNumeric } from '#src/lib/formatters/temporal';

export function getBillingDateString({ trialDuration }) {
  if (trialDuration.unit == 'day')
    return formatMonthDayNumeric(addDays(trialDuration.value, new Date()));
  else if (trialDuration.unit == 'month')
    return formatMonthDayNumeric(addMonths(trialDuration.value, new Date()));
}
